<script>
import formInput from "@/mixins/shared/formInput";
import Signature from "@wielink-application/shared/js/signature";


export default {
	mixins: [formInput],

	props: {
		height: {
			type: String,
			default: '185px'
		}
	},

	mounted() {
		this.initialiseSignature();

		this.$watch("modelValue", () => {
			let $signature = $(this.$refs.signature);
			let signature = $signature.data('signature')
			signature.setValue(this.modelValue, false);
		})
	},

	methods: {
		initialiseSignature() {
			let signature = new Signature({
				scope: this.$refs.signature
			})
			let $signature = $(this.$refs.signature);
			$signature.data('signature', signature);
			$signature.on('signature:change', (event, data) => {
				this.changeModelValueTo(data.value);
			})
		},

		clear() {
			let $signature = $(this.$refs.signature);
			$signature.data('signature').clear();
			$signature.trigger('signature:change', {value: null})
		}
	}
}
</script>

<template>
	<div>
		<canvas
			ref="signature"
			class="position-relative border rounded"
			:style="'background-color: var(--input-bg); width: 100%; height: ' + this.height"
			:class="{'border-danger' : hasError}"
			:data-value="modelValue"
		></canvas>

		<div class="d-flex align-items-center flex-wrap mt-2">
			<label v-if="hasError" class="text-danger small">{{ this.form.errors[this.name] }}</label>

			<div class="ms-auto">
				<button @click.prevent="clear" class="btn btn-sm btn-outline-secondary">
					<i class="bi bi-arrow-clockwise pe-2"></i>
					Opnieuw beginnen
				</button>
			</div>
		</div>
	</div>
</template>